import React from 'react';
import { Modal } from 'react-bootstrap';

const CalendlyPopup = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Schedule a Meeting</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe title="contact" src="https://calendly.com/contact-onlyglance/15min"></iframe>
      </Modal.Body>
    </Modal>
  );
};

export default CalendlyPopup;
